import { REGULAR_USER_BACKGROUND_IMAGE_URLS } from "./regularUserBackgroundPreload";
import { API_BASE_URL, API_ORIGIN_BASE_URL } from "./config/apiBaseUrl";

const TOKEN_STORAGE_KEY = "mysipur_auth_token";
const API_ASSET_BASE_URL = API_ORIGIN_BASE_URL;

const HOW_IT_WORKS_ICON_FILES = [
  "language.png",
  "story type.png",
  "pictures.png",
  "story.png",
  "submit.png",
];

const STATIC_STARTUP_IMAGE_URLS: readonly string[] = [
  ...REGULAR_USER_BACKGROUND_IMAGE_URLS,
  "https://pub-dd11db53b680447d86c08d43682efe32.r2.dev/images/home/logo.png",
  ...HOW_IT_WORKS_ICON_FILES.map(
    (file) =>
      `https://pub-dd11db53b680447d86c08d43682efe32.r2.dev/icons/${encodeURIComponent(file)}`
  ),
];

function preloadImage(src: string): Promise<void> {
  return new Promise((resolve) => {
    const img = new Image();
    const done = () => resolve();
    img.onload = done;
    img.onerror = done;
    img.src = src;
    if (img.complete) done();
  });
}

function normalizeUrl(raw: unknown): string | null {
  if (typeof raw !== "string") return null;
  const v = raw.trim();
  if (!v) return null;
  if (v.startsWith("blob:") || v.startsWith("data:")) return null;
  if (v.startsWith("http://") || v.startsWith("https://")) return v;
  if (v.startsWith("/")) return `${API_ASSET_BASE_URL}${v}`;
  return `${API_ASSET_BASE_URL}/${v}`;
}

async function fetchSignedInUserStoryImages(): Promise<string[]> {
  const token = sessionStorage.getItem(TOKEN_STORAGE_KEY);
  if (!token) return [];

  const authHeaders = { Authorization: `Bearer ${token}` };
  const requestResp = await fetch(`${API_BASE_URL}/stories/book-request`, {
    headers: authHeaders,
  }).catch(() => null);
  const requestPayload = await requestResp?.json().catch(() => null);
  const sessionId = requestPayload?.data?.sessionId;
  if (!sessionId) return [];

  const storyResp = await fetch(`${API_BASE_URL}/stories/${encodeURIComponent(sessionId)}`, {
    headers: authHeaders,
  }).catch(() => null);
  const storyPayload = await storyResp?.json().catch(() => null);
  const story = storyPayload?.data;
  if (!story) return [];

  const covers = [story.frontCover, story.backCover].filter(Boolean);
  const pageImages = Array.isArray(story.pageImages) ? story.pageImages : [];
  const allImageRecords = [...covers, ...pageImages];
  const extracted = allImageRecords.flatMap((entry: any) => [
    normalizeUrl(entry?.editedImageUrl),
    normalizeUrl(entry?.uploadedImageUrl),
    normalizeUrl(entry?.imageUrl),
  ]);
  return extracted.filter(Boolean) as string[];
}

export async function preloadStartupAssets(): Promise<void> {
  const urls = new Set<string>(STATIC_STARTUP_IMAGE_URLS);
  const userStoryUrls = await fetchSignedInUserStoryImages().catch(() => []);
  for (const src of userStoryUrls) urls.add(src);
  await Promise.all([...urls].map((src) => preloadImage(src)));
}

